<template>
  <div class="detail">
    <anav name="课程列表" @back="back"/>
    <div class="top">
      <h2>{{courseDetail.MyClassName}}</h2>
      <p>讲师：{{courseDetail.Teachers}}</p>
    </div>
    <div class="tabs">
      <div class="switch">
        <label :class="curTab === item ? 'select' : ''" @click="curTab = item" v-for="(item, idx) in ['catalog', 'teachers', 'answers']" :key="item">
          {{["目录", "老师", "答疑"][idx]}}
        </label>
      </div>
      <div class="not-data" style="border-top: 1px solid #eee"
        v-show="curTab === 'catalog'" v-if="!courseDetail.CourseList || (courseDetail.CourseList && courseDetail.CourseList.length === 0)">
        <img src="https://img2.233.com/wx/union/wap/leadaclass/not-data.png">
        <p>暂无内容</p>
      </div>
      <div class="catalog" v-show="curTab === 'catalog'" v-if="courseDetail.CourseList && courseDetail.CourseList.length > 0">
        <div class="class" v-if="courseDetail.CourseList.length > 1">
          <span>共包含{{courseDetail.CourseList.length}}个班级</span>
          <div class="labels">
            <label :class="curCourse === item.CourseId ? 'select' : ''" @click="changeCurCourse(item.CourseId)"
              v-for="item in courseDetail.CourseList" :key="item.CourseId">
              {{item.CourseName}}
            </label>
          </div>
        </div>
        <div class="item" v-for="item in myclassChapterAndNode" :key="item.ID">
          <div class="title">{{item.ZjName}}</div>
          <div class="list">
            <p v-for="ii in item.ChapterNodeList" :key="ii.ChapterNodeID">{{ii.ChapterNodeName}}</p>
          </div>
        </div>
      </div>
      <div class="teachers" v-show="curTab === 'teachers'">
        <div class="not-data" v-if="!courseDetail.TeacherList || (courseDetail.TeacherList && courseDetail.TeacherList.length === 0)">
          <img src="https://img2.233.com/wx/union/wap/leadaclass/not-data.png">
          <p>暂无内容</p>
        </div>
        <div class="teacher" v-for="(item, idx) in courseDetail.TeacherList" :key="idx">
          <div class="info">
            <div class="left">
              <img :src="item.PicPath ? item.PicPath : '//img2.233.com/boss/course/teacher/20200110-800x800-lq-01.jpg'">
            </div>
            <div class="right">
              <span>{{item.Name}}</span>
              <!-- <p>副教授、中国注册会计师、会计师职称</p> -->
            </div>
          </div>
          <div class="introduce" v-html="item.Introduction"/>
        </div>
      </div>
      <div class="answers" v-show="curTab === 'answers'">
        <div class="loading" v-if="answerLoading">
          <img src="https://img2.233.com/wx/union/wap/leadaclass/loading.png">
        </div>
        <div class="not-data" v-if="askAnswerByMyclassIdList.length === 0 && !answerLoading">
          <img src="https://img2.233.com/wx/union/wap/leadaclass/not-data.png">
          <p>暂无内容</p>
        </div>
        <template v-if="!answerLoading">
          <div class="box" v-for="item in askAnswerByMyclassIdList" :key="item.Id">
            <div class="info">
              <div class="left">
                <img :src="item.StudentPic" v-if="item.StudentPic">
                <img src="https://img.233.com/wx/img/union/defaultimgs/defaultheader.png" v-else>
              </div>
              <div class="right">
                <span>{{item.UserName}}</span>
                <p>来源：{{item.FromwebName}}</p>
              </div>
            </div>
            <div class="problem">
              <p>
                <img src="https://img2.233.com/wx/union/wap/leadaclass/question-icon.png">
                <span>{{item.Content}}</span>
              </p>
              <div class="imgs" v-if="item.Relates && item.Relates.length > 0">
                <img v-for="imgs in item.Relates.filter(v => v.Types === 2)" :key="imgs.Path" :src="imgs.Path" @click="viewBigImg(imgs.Path)">
              </div>
            </div>
            <div class="answer" v-if="item.Replies[0]">
              <img src="https://img2.233.com/wx/union/wap/leadaclass/triangle.png" class="triangle">
              <p>
                <img src="https://img2.233.com/wx/union/wap/leadaclass/answer-icon.png">
                <span>{{item.Replies[0].Content}}</span>
              </p>
              <div class="imgs" v-if="item.Replies[0].Relates && item.Replies[0].Relates.length > 0">
                <img v-for="imgs in item.Replies[0].Relates.filter(v => v.Types === 2)" :key="imgs.Path" :src="imgs.Path" @click="viewBigImg(imgs.Path)">
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="fixed">
      <div class="left">
        <span>免费</span>
        <del v-if="courseDetail.GoodPrice !== 0">¥{{courseDetail.GoodPrice}}</del>
      </div>
      <div class="right" @click="receiving" v-if="courseDetail.isbuy === 0">立即领取</div>
      <div class="right" @click="toAppStudy" v-else>去学习</div>
    </div>
    <ReceivingCourses ref="receivingCourses" :promoteCode="promoteCode"/>
    <div class="view-big-img" v-show="viewBigImgShow">
      <img class="big-img" :src="bigImgUrl">
      <div class="close" @click="viewBigImgShow = false"/>
    </div>
    <div class="dialog" v-show="tips">
      <div class="tips">{{tips}}</div>
    </div>
  </div>
</template>

<script>
import anav from "../../components/nav/index"
import ReceivingCourses from "../../components/receivingCourses/index"
import { GetLoginStatus, GetCourseDetail, GetMyclassChapterAndNode, GetAskAnswerByMyclassIdList } from "../../lib/request"
export default {
  name: "Detail",
  components: {
    anav,
    ReceivingCourses
  },
  data() {
    return {
      formList: false,
      promoteCode: "",
      courseDetail: {},
      curTab: "catalog",
      curCourse: 0,
      myclassChapterAndNode: [],
      answerLoading: false,
      askAnswerByMyclassIdList: [],
      viewBigImgShow: false,
      bigImgUrl: "",
      tips: ""
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.formList = from.path && from.path !== "/")
  },
  created() {
    if (this.$route.query.promoteCode) {
      this.promoteCode = this.$route.query.promoteCode
    } else {
      location.href = "https://v.233.com/"
    }
    this.GetCourseDetail()
    this.GetAskAnswerByMyclassIdList()
  },
  mounted() {
    this.GetLoginStatus()
  },
  methods: {
    GetLoginStatus() {
      if (window.location.href.indexOf("v.233.com") > -1) {
        document.title = "课程列表"
      } else {
        GetLoginStatus({}, (res) => {
          const { Result } = res
          document.title = Result.webName ? "课程列表-" + Result.webName : "课程列表"
        })
      }
    },
    back() {
      this.formList ? this.$router.go(-1) : this.$router.push({ path: '/', query: { promoteCode: this.promoteCode }})
    },
    GetCourseDetail() {
      GetCourseDetail({ promoteCode: this.promoteCode, myclassId: this.$route.query.id }, (res) => {
        if (res.ResultDescription) {
          this.tips = res.ResultDescription
          setTimeout(() => {
            this.tips = ""
          }, 3000)
        } else {
          const { reData, isbuy } = res.Result
          this.courseDetail = { ...reData, isbuy }
          if (this.courseDetail.CourseList && this.courseDetail.CourseList[0]) {
            this.curCourse = this.courseDetail.CourseList[0].CourseId
            this.GetMyclassChapterAndNode(this.curCourse)
          }
        }
      })
    },
    GetMyclassChapterAndNode(myclassId) {
      GetMyclassChapterAndNode({ myclassId }, (res) => {
        if (res.ResultDescription) {
          this.myclassChapterAndNode = []
          this.tips = res.ResultDescription
          setTimeout(() => {
            this.tips = ""
          }, 3000)
        } else {
          this.myclassChapterAndNode = res.Result
        }
      })
    },
    changeCurCourse(CourseId) {
      this.curCourse = CourseId
      this.GetMyclassChapterAndNode(CourseId)
    },
    GetAskAnswerByMyclassIdList() {
      this.answerLoading = true
      // GetAskAnswerByMyclassIdList({ myclassid: 33140, pIndex: 1,  pSize: 10000 }, (res) => {
      GetAskAnswerByMyclassIdList({ myclassid: this.$route.query.id, pIndex: 1,  pSize: 10000 }, (res) => {
        this.answerLoading = false
        this.askAnswerByMyclassIdList = res.Result
      })
    },
    receiving() {
      this.$refs["receivingCourses"].LoginInfoByPromote(this.$route.query.id)
    },
    toAppStudy() {
      location.href = location.host === 'v.233.com' ? "https://www.233.com/shouji233/" : location.origin + "/search/app"
    },
    viewBigImg(url) {
      this.viewBigImgShow = true
      this.bigImgUrl = url
    }
  }
}
</script>

<style lang="scss" scoped>
.detail{
  padding-bottom: 60px;
  .top{
    background: #fff;
    padding: 15px 16px;
    border-top: 1px solid #eee;
    h2{
      font-size: 16px;
      color: #333;
      font-weight: 800;
      line-height: 22px;
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    p{
      font-size: 12px;
      color: #8A8A8A;
      font-weight: 400;
      margin-top: 10px;
      line-height: 16px;
    }
  }
  .tabs{
    .switch{
      margin-top: 10px;
      background: #fff;
      label{
        color: #999;
        font-size: 15px;
        font-weight: 800;
        display: inline-block;
        width: 33.33%;
        text-align: center;
        height: 50px;
        line-height: 50px;
        cursor: pointer;
      }
      .select{
        font-size: 18px;
        color: #333;
        position: relative;
        &::before{
          content: "";
          position: absolute;
          bottom: 0;
          left: calc(50% - 9.5px);
          width: 19px;
          height: 4px;
          background: #E13B29;
          border-radius: 2px;
        }
      }
    }
    .not-data{
      text-align: center;
      padding: 100px 0;
      background: #fff;
      img{
        width: 147px;
        height: 134px;
      }
      p{
        color: #333;
        font-size: 16px;
        font-weight: 400;
        line-height: 16px;
        margin-top: 18px;
      }
    }
    .catalog{
      margin: 10px;
      .class{
        background: #fff;
        padding: 15px 17px 23px;
        border-radius: 5px;
        span{
          display: inline-block;
          color: #A66D54;
          font-size: 14px;
          line-height: 14px;
          font-weight: 400;
          padding: 7px 13px;
          background: #FDF6EF;
          border-radius: 13px;
          margin-bottom: 11px;
        }
        .labels{
          label{
            display: inline-block;
            height: 38px;
            line-height: 38px;
            border: 1px solid #eee;
            border-top: none;
            font-size: 14px;
            color: #333;
            font-weight: 400;
            width: 100%;
            padding-left: 22px;
            box-sizing: border-box;
            cursor: pointer;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: top;
            &:nth-child(1){
              border-top: 1px solid #eee;
            }
          }
          .select{
            background: #FDF6EF;
            border: 1px solid #FDF6EF !important;
            line-height: 36px;
            color: #A66D54;
          }
        }
      }
      .item{
        padding-top: 9px;
        .title{
          color: #333;
          font-size: 14px;
          height: 14px;
          line-height: 14px;
          font-weight: 800;
          padding-left: 7px;
          border-left: 2px solid #E63A18;
          margin: 5px 0 16px;
        }
        .list{
          background: #fff;
          padding: 0 12px;
          border-radius: 5px;
          p{
            height: 40px;
            line-height: 40px;
            border-radius: 5px;
            font-size: 13px;
            color: #333;
            font-weight: 400;
            border-bottom: 1px solid #eee;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            &:nth-last-child(1) {
              border-bottom: none;
            }
          }
        }
      }
    }
    .teachers{
      border-top: 1px solid #eee;
      padding: 0 24px;
      background: #fff;
      .teacher{
        border-bottom: 1px solid #eee;
        padding: 19px 0;
        &:nth-last-child(1){
          border-bottom: 0;
        }
        .info{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left{
            width: 50px;
            height: 50px;
            img{
              width: 50px;
              height: 50px;
              object-fit: cover;
              border-radius: 25px;
            }
          }
          .right{
            width: calc(100% - 70px);
            margin-left: 20px;
            span{
              color: #333;
              font-size: 15px;
              line-height: 15px;
              font-weight: 800;
            }
            p{
              margin-top: 11px;
              color: #666;
              font-weight: 400;
              font-size: 13px;
              line-height: 13px;
            }
          }
        }
        .introduce{
          color: #666;
          font-size: 13px;
          font-weight: 400;
          line-height: 24px;
          margin-top: 16px;
        }
      }
    }
    .answers{
      border-top: 1px solid #eee;
      padding: 0 24px;
      background: #fff;
      .loading{
        text-align: center;
        padding: 30px 0;
        img{
          width: 40px;
          animation:turn 1.2s linear infinite; 
        }
      }
      @keyframes turn{
        0%{-webkit-transform:rotate(0deg);}
        25%{-webkit-transform:rotate(120deg);}
        50%{-webkit-transform:rotate(220deg);}
        75%{-webkit-transform:rotate(300deg);}
        100%{-webkit-transform:rotate(360deg);}
      }
      .box{
        border-bottom: 1px solid #eee;
        padding: 19px 0;
        &:nth-last-child(1){
          border-bottom: 0;
        }
        .info{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left{
            width: 50px;
            height: 50px;
            img{
              width: 50px;
              height: 50px;
              object-fit: cover;
              border-radius: 25px;
            }
          }
          .right{
            width: calc(100% - 70px);
            margin-left: 20px;
            span{
              color: #333;
              font-size: 15px;
              line-height: 15px;
              font-weight: 800;
            }
            p{
              margin-top: 11px;
              color: #666;
              font-weight: 400;
              font-size: 13px;
              line-height: 13px;
            }
          }
        }
        .problem{
          font-size: 13px;
          color: #666;
          font-weight: 400;
          line-height: 19px;
          margin: 10px 0;
          p{
            display: flex;
            img{
              width: 18px;
              height: 16px;
              margin-right: 8px;
            }
          }
          .imgs{
            margin-top: 8px;
            margin-left: 26px;
            img{
              width: 77px;
              height: 52px;
              margin-right: 10px;
              object-fit: cover;
            }
          }
        }
        .answer{
          background: #F3F3F3;
          padding: 13px 18px 13px 10px;
          color: #666;
          font-size: 13px;
          font-weight: 400;
          position: relative;
          .triangle{
            position: absolute;
            top: -8px;
            width: 13px;
            left: 15px;
          }
          p{
            display: flex;
            img{
              width: 18px;
              height: 16px;
              margin-right: 8px;
            }
          }
          .imgs{
            margin-top: 8px;
            margin-left: 26px;
            img{
              width: 77px;
              height: 52px;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
  .fixed{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;    
    height: 60px;
    background: #FFFFFF;
    box-shadow: -1px -3px 16px 0px rgba(219, 219, 219, 0.4);
    display: flex;
    justify-content: space-between;
    .left{
      span{
        color: #E13B29;
        font-size: 25px;
        font-weight: 800;
        margin: 0 11px 0 23px;
        line-height: 60px;
      }
      del{
        color: #999;
        font-size: 12px;
        font-weight: 400;
      }
    }
    .right{
      width: 110px;
      height: 60px;
      line-height: 60px;
      background: #E13B29;
      font-size: 17px;
      color: #fff;
      font-weight: 400;
      text-align: center;
      cursor: pointer;
    }
  }
  .view-big-img{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1010;
    background: rgba(0, 0, 0, .5);
    text-align: center;
    .big-img{
      max-width: 80%;
      max-height: 80%;
      margin-top: 10%;
    }
    .close{
      position: absolute;
      top: 30px;
      right: 30px;
      width: 30px;
      height: 30px;
      background: url("https://img2.233.com/wx/union/wap/leadaclass/close-icon.png") no-repeat;
      background-size: 100%;
      cursor: pointer;
    }
  }
  .dialog{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 101;
    background: rgba(0, 0, 0, .5);
    .tips{
      position: fixed;
      z-index: 222;
      top: 50%;
      left: 50%;
      margin-left: -111px;
      width: 222px;
      text-align: center;
      padding: 20px 36px;
      box-sizing: border-box;
      color: #fff;
      font-weight: 400;
      font-size: 15px;
      background: rgba(0, 0, 0, .8);
      border-radius: 10px;
      margin-top: -30px;
    }
  }
}
</style>